import differenceInHours from 'date-fns/differenceInHours'
import differenceInDays from 'date-fns/differenceInDays'
import differenceInMonths from 'date-fns/differenceInMonths'
import differenceInWeeks from 'date-fns/differenceInWeeks'
import differenceInMinutes from 'date-fns/differenceInMinutes'
import startOfDay from 'date-fns/startOfDay'
import format from 'date-fns/format'
import subDays from 'date-fns/subDays'
import subMonths from 'date-fns/subMonths'

export const getTimeDiff = (date1: string, date2 = '', long = false) => {
  const d1 = date1 ? new Date(date1) : new Date()
  const d2 = date2 ? new Date(date2) : new Date()
  let diff = differenceInMonths(d2, d1)
  if (diff >= 1) {
    return `${diff} month${diff !== 1 ? "'s" : ''}`
    return long ? `${diff} month${diff > 1 ? 's' : ''} ago` : `${diff} m`
  }
  diff = differenceInWeeks(d2, d1)
  if (diff >= 1) {
    return long ? `${diff} week${diff > 1 ? 's' : ''} ago` : `${diff} w`
  }
  diff = differenceInDays(d2, d1)
  if (diff >= 1) {
    return long ? `${diff} day${diff > 1 ? 's' : ''} ago` : `${diff} d`
  }
  diff = differenceInHours(d2, d1)
  if (diff >= 1) {
    return long ? `${diff} hour${diff > 1 ? 's' : ''} ago` : `${diff} h`
  }
  diff = differenceInMinutes(d2, d1)
  if (diff >= 1) {
    return long ? `${diff} minute${diff > 1 ? 's' : ''} ago` : `${diff} m`
  }
  return 'now'
}

export const getStartDate = (period: string, date?: string, isNFT?: boolean) => {
  let day = date ? (new Date(date)) : (new Date())
  if ((period === '1D') || (period === '24H')) {
    day = subDays(day, 1)
  } else if ((period === '1W') || (period === '7D')) {
    day = startOfDay(subDays(day, 7))
  } else if (period === '14D') {
    day = startOfDay(subDays(day, 14))
  } else if (period === '30D') {
    day = startOfDay(subDays(day, 30))
  } else if (period === '60D') {
    day = startOfDay(subDays(day, 60))
  } else if (period === '90D') {
    day = startOfDay(subDays(day, 90))
  } else if (period === '1M') {
    day = startOfDay(subDays(day, 30))
  } else if (period === '6M') {
    day = startOfDay(subMonths(day, 6))
  } else if (period === '1Y') {
    day = startOfDay(subMonths(day, 12))
  } else if (period === '5Y' && isNFT) {
    day = startOfDay(subMonths(day, 20))
  } else if (period === '5Y') {
    day = startOfDay(subMonths(day, 60))
  }

  return format(day, 'yyyy-MM-dd\'T\'HH:mm:ssXX')
}

export const isToday = (date: Date) => new Date().toDateString() === date.toDateString()

export const isYesterday = (date: Date) => {
  const yesterday = new Date()
  yesterday.setDate(yesterday.getDate() - 1)

  return yesterday.toDateString() === date.toDateString()
}

export const isDateInThisWeek = (date: Date) => {
  const todayObj = new Date();
  const todayDate = todayObj.getDate();
  const todayDay = todayObj.getDay();

  const firstDayOfWeek = new Date(todayObj.setDate(todayDate - todayDay));

  const lastDayOfWeek = new Date(firstDayOfWeek);
  lastDayOfWeek.setDate(lastDayOfWeek.getDate() + 6);

  return date >= firstDayOfWeek && date <= lastDayOfWeek;
}

export function getFirstDay(date: Date) {
  const currentDate = new Date(date);
  const first = currentDate.getDate() - currentDate.getDay();
  const firstday = new Date(currentDate.setDate(first));
  return firstday;
}
